import CameraControls from 'camera-controls';
import type { Camera, Scene, WebGLRenderer } from 'three';
import * as THREE from 'three';
import { OrthographicCamera, PerspectiveCamera } from 'three';

// Initialize camera-controls
CameraControls.install({ THREE });

export default class ThreeWrapper {
  // #region MAIN
  camera: Camera | PerspectiveCamera | OrthographicCamera;
  renderer: WebGLRenderer;
  camControl: CameraControls;
  scene: Scene;

  constructor(
    scene: Scene,
    renderer: WebGLRenderer,
    camera?: Camera | PerspectiveCamera | OrthographicCamera,
    camCtrl?: CameraControls,
  ) {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    this.scene = scene;
    this.renderer = renderer;

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Camera Setup
    this.camera =
      camera ??
      new PerspectiveCamera(
        75,
        renderer.domElement.clientWidth / renderer.domElement.clientHeight,
        0.1,
        1000,
      );

    this.camControl =
      camCtrl ??
      new CameraControls(this.camera as PerspectiveCamera, renderer.domElement);
  }
  // #endregion

  // #region CAMERA
  sphericalLook(
    lon: number,
    lat: number,
    radius: number,
    target?: Array<number>,
  ): this {
    const phi = ((90 - lat) * Math.PI) / 180;
    const theta = ((lon + 180) * Math.PI) / 180;

    this.camera.position.set(
      -(radius * Math.sin(phi) * Math.sin(theta)),
      radius * Math.cos(phi),
      -(radius * Math.sin(phi) * Math.cos(theta)),
    );

    if (target) {
      this.camControl.setLookAt(
        this.camera.position.x,
        this.camera.position.y,
        this.camera.position.z,
        target[0],
        target[1],
        target[2],
        false,
      );
    }
    this.camControl.update(0.016); // ~60fps delta
    return this;
  }
  // #endregion

  // #region RENDERING

  render(
    scene?: THREE.Scene,
    camera?: Camera | PerspectiveCamera | OrthographicCamera,
  ) {
    this.renderer.render(scene ?? this.scene, camera ?? this.camera);
  }

  // #endregion
}
